import type { AxiosError } from 'axios';

export function getSnapshotApiErrorMessage(err: unknown, fallback: string): string {
  const ax = err as AxiosError<{ error?: { message?: string; details?: unknown } }>;
  const api = ax.response?.data?.error;
  if (api?.message) return api.message;
  return fallback;
}

export function getUnmappedStagesFromError(err: unknown): string[] {
  const ax = err as AxiosError<{
    error?: { details?: { unmappedStages?: string[] } };
  }>;
  return ax.response?.data?.error?.details?.unmappedStages ?? [];
}
